// eslint-disable-next-line import/prefer-default-export
export const CARD_TYPES = {
  invitation: 'INVITATION',
  std: 'SAVE_THE_DATE',
  ctd: 'CHANGE_THE_DATE',
  thankyou: 'THANK_YOU',
  menu: 'MENU',
  program: 'PROGRAM',
  holiday: 'HOLIDAY',
  enclosure: 'ENCLOSURE'
};




// WEBPACK FOOTER //
// ./src/cards/constants/CardTypes.js